import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { TenantsService } from '../../core/services/tenants.service';
import { companyConfigService } from '../services/company-config.service';
import { environment } from '../../../environments/environment';

import { AppConstants_settings } from '../AppConstants_Appsettings.enum';

export const customInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  // Bypass interceptor for custom Node.js CMS API requests so guest token is not attached unnecessarily
  if (req.url.includes('localhost:5000') || req.url.includes('/api/cms/')) {
    return next(req);
  }

  const cookieService = inject(CookieService);
  const TenantsSer = inject(TenantsService);
  const companyConfig = inject(companyConfigService);
  const tenantId = TenantsSer.getTenantFromSubdomain(); // Get the tenant ID from the service
  let clientapikey = '';
  const compId = AppConstants_settings.COMPANY_ID || 'NS';
  if (tenantId === 'NS' || compId === 'NS') {
    clientapikey = 'NS123'; // Set the client API key for NS tenant
  }
  let token = cookieService.get('guestToken'); // use the injected service
  if (token == null || token == '') {
    token = JSON.parse(JSON.stringify(companyConfig.getGuestToken())).guesttoken;
  }
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      'x-client-apikey': clientapikey,
    },
  });

  // Pass the modified request to the next handler
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('HTTP error intercepted:', error);
      return throwError(() => error);
    })
  );
};
